import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { Form, Radio, Space } from 'antd';

import { ApplicationUIContext, DrawerContent, DrawerTabs } from '@yuhuinc/ui-library';

import SearchApplicants from '../common/SearchApplicants';
import NewOrEditApplicant from '../common/NewOrEditApplicant';

import { getTranslatedString } from 'helpers/i18n';
import { ContactMethod } from '../additional_information/ContactMethod';
import { buildInitialValuesForSelectedApplicant } from '../common/helpers';
import NewApplicantErrorAlert from '../common/NewApplicantError';

const RADIO_GROUP_OPTIONS = [
  {
    value: 'search',
    label: getTranslatedString(
      'landlordPortal.applicationManagement.inviteLeadToApply.searchApplicants'
    ),
  },
  {
    value: 'new',
    label: getTranslatedString(
      'landlordPortal.applicationManagement.inviteLeadToApply.newApplicant'
    ),
  },
];

const validationRules = [
  {
    required: true,
    message: getTranslatedString(
      'landlordPortal.applicationManagement.inviteLeadToApply.requiredField'
    ),
  },
];

export const applicantTypeRadios = (
  <Form.Item
    label={getTranslatedString(
      'landlordPortal.applicationManagement.inviteLeadToApply.addAdditionalApplicant.applicantType'
    )}
    name="applicant_type"
    rules={validationRules}
  >
    <Radio.Group>
      <Space direction="vertical">
        <Radio value="coapplicant">
          {getTranslatedString(
            'landlordPortal.applicationManagement.inviteLeadToApply.addAdditionalApplicant.applicantType.coapplicant'
          )}
        </Radio>
        <Radio value="guarantor">
          {getTranslatedString(
            'landlordPortal.applicationManagement.inviteLeadToApply.addAdditionalApplicant.applicantType.guarantor'
          )}
        </Radio>
        <Radio value="occupant">
          {getTranslatedString(
            'landlordPortal.applicationManagement.inviteLeadToApply.addAdditionalApplicant.applicantType.occupant'
          )}
        </Radio>
      </Space>
    </Radio.Group>
  </Form.Item>
);

const AssignAdditionalApplicant = ({
  selectedApplicant,
  siteAndProperties,
  loadingSiteAndProperties,
  onAdd,
  closeDrawer,
}) => {
  let initialAssignmentType = selectedApplicant && !selectedApplicant.id ? 'new' : 'search';

  const { isMobile } = useContext(ApplicationUIContext);
  const [assignmentType, setAssignmentType] = useState(initialAssignmentType);
  const [newApplicantError, setNewApplicantError] = useState(false);

  function onAssignmentTypeChange({ target: { value } }) {
    setAssignmentType(value);
  }

  function onSelectFoundAdditionalApplicant(selectedApplicant, { applicant_type }) {
    onAdd({ ...selectedApplicant, applicant_type });
    closeDrawer();
  }

  function onSubmitAdditionalApplicant(newApplicant) {
    onAdd(newApplicant);
    closeDrawer();
  }

  return (
    <DrawerContent>
      {newApplicantError && <NewApplicantErrorAlert {...newApplicantError} isMobile={isMobile} />}
      <DrawerTabs
        value={assignmentType}
        onChange={onAssignmentTypeChange}
        options={RADIO_GROUP_OPTIONS}
      />
      {assignmentType === 'search' && (
        <SearchApplicants
          mode={selectedApplicant ? 'update_additional_applicant' : 'add_additional_applicant'}
          siteAndProperties={siteAndProperties}
          initialValues={
            selectedApplicant
              ? {
                  query: selectedApplicant.full_name,
                  applicant_type: selectedApplicant.applicant_type,
                }
              : {}
          }
          extraFormItems={applicantTypeRadios}
          loadingSiteAndProperties={loadingSiteAndProperties}
          onSelect={onSelectFoundAdditionalApplicant}
          onCancel={closeDrawer}
        />
      )}
      {assignmentType === 'new' && (
        <NewOrEditApplicant
          initialValues={buildInitialValuesForSelectedApplicant(selectedApplicant || {})}
          extraFormItems={
            <>
              <ContactMethod />
              {applicantTypeRadios}
            </>
          }
          onSubmit={onSubmitAdditionalApplicant}
          onCancel={closeDrawer}
          onError={setNewApplicantError}
        />
      )}
    </DrawerContent>
  );
};

AssignAdditionalApplicant.propTypes = {
  selectedApplicant: PropTypes.any,
  siteAndProperties: PropTypes.array,
  loadingSiteAndProperties: PropTypes.bool,
  onAdd: PropTypes.func,
  closeDrawer: PropTypes.func,
};

export default AssignAdditionalApplicant;
